import React, { useState } from 'react';
import Logo from "../images/logo.svg";
import Select from 'react-select';

function ComplianceReports() {
  const [copied, setCopied] = useState(false);

  const copyText = (text) => {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000); 
  };

 const options = [
    { value: 'India', label: 'India' },
    { value: 'United States', label: 'United States' },
    { value: 'Australia', label: 'Australia' }
  ]
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      console.log({ data, isDisabled, isFocused, isSelected });
      return {
        ...styles,
        backgroundColor: isFocused ? "#F8F8F8" : "",
        color: "#333333",
        borderBottom:1,
        borderStyle:"solid",
        borderColor:"#F2F2F2",
        fontSize:14,
        fontWeight:500,
      };
    }
  };

  const [selectedOption, setSelectedOption] = useState(null);
    // handle onChange event of the dropdown
    const handleChange = e => {
      setSelectedOption(e);
    }

  return (
    <>
    <div id='header'>
        <div className='logo'>
            <div className='logo_icon'>
                <img src={Logo} />
            </div>
            <div className='brand_name'>Compliance reports</div>
        </div>

        <div className='header_table_filter'>
            <div className='searchfield'>
                <button className='btn_search'><i className='icon-search'></i></button>
                <input type='text' className='filter_searchfield' placeholder='Search by ISIN' />
            </div>

            <div className='dropdown_col_filter dropdown_select'>
                <Select options={options}
                styles={colourStyles}
                placeholder="Both Statuses" />
            </div>
            <div className='dropdown_col_filter dropdown_select'>
                <Select options={options}
                styles={colourStyles}
                placeholder="All Countries" />
            </div>
            <div className='dropdown_col_filter dropdown_select'>
                <Select options={options}
                styles={colourStyles}
                placeholder="All Compliance" />
            </div>

            <a href='#' className="btn_clear_filter">Clear Filters</a>
        </div>
    </div>
    <div className="container-fluid content pb-5">
      <div className='company_table_list'>
        <div className='table-responsive'>
          <table className='table'>
              <thead>
                <tr>
                  <th>Stock</th>
                  <th>Company</th>
                  <th>ISIN</th>
                  <th>Country</th>
                  <th>Exch</th>
                  <th style={{textAlign:'center'}}>Compliance</th>
                  <th>Username</th>
                  <th>Status</th>
                  <th>Updated</th>
                  <th>Year</th>
                  <th>Quarter</th>
                  <th>Form</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>543375.BO</span>
                    </div>
                    </td>
                  <td>Promax Power Ltd</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("INE0I2F01015")}>
                      INE0I2F01015  
                     {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td>India</td>
                  <td>BSE</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com 
                  </div>    
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>SECOND_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr> 

                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>522195.BO</span>
                    </div>
                    </td>
                  <td>Algoma Central Corp</td>
                  <td>
                    <div className="table_td_big_content_url" onClick={() => copyText("NE572D01014")}>
                     NE572D01014  
                     {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td>India</td>
                  <td>BSE</td>
                  <td><span className='halal_tag tag_td'>Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    bobur.madi@musaffa.com
                  </div>                      
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>THIRD_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>VMC.V</span>
                    </div>
                    </td>
                  <td>Vecima Networks Inc</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("CA9256541058")}>
                    CA9256541058  
                     {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td>Canada</td>
                  <td>TSXV</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com      
                  </div>
                  </td>
                  <td><span className='status_unpublish'><i className="icon-cross"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>ANNUAL</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr> 
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>ESOA</span>
                    </div>
                    </td>
                  <td>Angel Oak Financial Str</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("US29271Q1031")}>
                    US29271Q1031
                     {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td>United States</td>
                  <td>NASDAQ</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com      
                  </div>  
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>FIRST_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr> 
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>ALAR.TA</span>
                    </div>
                    </td>
                  <td>Frontera Energy Corp</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("IL0010838568")}>
                    IL0010838568
                     {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td>Israel</td>
                  <td>TASE</td>
                  <td><span className='halal_tag tag_td'>Halal</span></td>                  
                  <td>
                    <div className='text_ellipsis'>
                      shohzod.xurram@musaffa.com  
                    </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>ANNUAL</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr> 
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>500213.BO</span>
                    </div>
                    </td>
                  <td>Spartan Delta Corp</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("INE262B01016")}>
                    INE262B01016
                     {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td>India</td>
                  <td>BSE</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                     hojiakbar.obobak@musaffa.com      
                  </div>                    
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>THIRD_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>                           
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>TRC1.F</span>
                    </div>
                    </td>
                  <td>Mercer International Inc</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("CA8946478259")}>
                    CA8946478259
                     {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                  </td>
                  <td>Germany</td>
                  <td>XFRA</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com        
                  </div>                    
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>ANNUAL</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>TML.TO</span>
                    </div>
                    </td>
                  <td>Thinkific Labs Inc</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("US4516951005")}>
                     US4516951005  
                    {copied && <div className='copied_text'>Copied!</div>}
                  </div>
                  </td>
                  <td>Canada</td>
                  <td>BD</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com        
                  </div>  
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>ANNUAL</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>TRC1.DU</span>
                    </div>
                    </td>
                  <td>AAC Technologies Hold</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("US4516951005")}>
                    US4516951005
                    {copied && <div className='copied_text'>Copied!</div>}
                   </div>
                   </td>
                  <td>Germany</td>
                  <td>SWB</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com             
                  </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>ANNUAL</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>TRC1.SG</span>
                    </div>
                    </td>
                  <td>AAC Technologies Hold</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("US4516951005")}>
                    US4516951005
                    {copied && <div className='copied_text'>Copied!</div>}
                  </div>
                  </td>
                  <td>Germany</td>
                  <td>XFRA</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com                 
                  </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>ANNUAL</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>542753.BO</span>
                    </div>
                    </td>
                  <td>Solaris Resources Inc</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("US4516951005")}>
                      US4516951005
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                    </td>
                  <td>India</td>
                  <td>BSE</td>
                  <td><span className='halal_tag tag_td'>Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                  abbos.rasul@musaffa.com     
                  </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>THIRD_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>543514.BO</span>
                    </div>
                    </td>
                  <td>AAC Technologies Hold</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("INE0IQ001011")}>
                    INE0IQ001011
                    {copied && <div className='copied_text'>Copied!</div>}
                   </div>
                  </td>
                  <td>India</td>
                  <td>BSE</td>
                  <td><span className='halal_tag tag_td'>Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    hojiakbar.oboba@musaffa.com 
                  </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>THIRD_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>532801.BO</span>
                    </div>
                    </td>
                  <td>Park Lawn Corp</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("INE627H01017")}>
                    INE627H01017
                    {copied && <div className='copied_text'>Copied!</div>}
                  </div>
                  </td>
                  <td>United States</td>
                  <td>BSE</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    bobur.madi@musaffa.com 
                  </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>THIRD_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>CTE.NS</span>
                    </div>
                    </td>
                  <td>Rogers Sugar Inc</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("INE627H01017")}>
                      INE627H01017
                      {copied && <div className='copied_text'>Copied!</div>}
                    </div>
                    </td>
                  <td>India</td>
                  <td>NSE</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    bobur.madi@musaffa.com
                  </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>THIRD_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className='company_name_td'>
                    <span className='stock_lable'>63MOONS.NS</span>
                    </div>
                    </td>
                  <td>Kura Sushi USA Inc</td>
                  <td>
                  <div className="table_td_big_content_url" onClick={() => copyText("INE111B01023")}>
                    INE111B01023
                    {copied && <div className='copied_text'>Copied!</div>}
                  </div>
                  </td>
                  <td>India</td>
                  <td>NSE</td>
                  <td><span className='not_halal_tag tag_td'>Not Halal</span></td>                  
                  <td>
                  <div className='text_ellipsis'>
                    asilbek.solijon@musaffa.com  
                  </div>
                  </td>
                  <td><span className='status_active'><i className="icon-check"></i></span></td>
                  <td>Apr 8, 2024</td>
                  <td>2023</td>
                  <td>THIRD_QUARTER</td>
                  <td>NEW</td>
                  <td>
                    <div className='action_row'>
                        <a href='#' className='btn_create_report'>
                        Show Report
                        </a>
                        <a href='#' className='btn_icon_action'><i className='icon-view-file'></i></a>
                    </div>
                  </td>
                </tr>
              </tbody> 
          </table>
        </div>

        <nav aria-label="..." id='pagination_row'>
            <ul class="pagination">
                <li class="page-item disabled">
                <a class="page-link"><i className='icon-prev'></i></a>
                </li>
                <li class="page-item"><a class="page-link" href="#">1</a></li>
                <li class="page-item active" aria-current="page">
                <a class="page-link" href="#">2</a>
                </li>
                <li class="page-item"><a class="page-link" href="#">3</a></li>
                <li class="page-item"><a class="page-link" href="#">4</a></li>
                <li class="page-item"><a class="page-link" href="#">5</a></li>
                <li class="page-item">
                <a class="page-link" href="#"><i className='icon-next'></i></a>
                </li>
            </ul>
            </nav>
      </div>
    </div>
    </>
  );
}

export default ComplianceReports;
